import React, { memo, useMemo } from 'react';

const Button = memo(function Button({ children, onClick, type = 'button', className = '', variant = 'primary', ...props }) {
  const baseStyles = useMemo(() => 
    'px-5 py-2.5 rounded-lg font-semibold shadow-md transition-all duration-200 ease-in-out transform-gpu hover:scale-[1.02] hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-opacity-75 will-change-transform', 
    []
  );

  const variantStyles = useMemo(() => ({
    primary: 'bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500',
    secondary: 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-400',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    outline: 'bg-white text-indigo-600 border border-indigo-400 hover:bg-indigo-50 focus:ring-indigo-500',
    success: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500',
  }), []);

  const buttonStyles = useMemo(() => 
    `${baseStyles} ${variantStyles[variant]} ${className} disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:hover:shadow-md`,
    [baseStyles, variantStyles, variant, className]
  );

  return (
    <button
      type={type}
      onClick={onClick}
      className={buttonStyles}
      {...props}
    >
      {children}
    </button>
  );
});

export default Button;